import { fabric } from 'fabric';

// Text objects should only be resized by changing the font size (in the
// text toolbar), not by dragging the corner/edge handles. Rotation
// stays enabled.
export const disableTextResizeHandles = (object: fabric.Object) => {
  object.lockScalingX = true;
  object.lockScalingY = true;
  object.setControlsVisibility({
    ml: false,
    mr: false,
    mt: false,
    mb: false,
    tl: false,
    tr: false,
    bl: false,
    br: false,
    mtr: true,
  });
};
